<template>
  <router-view />
</template>

<script>
  export default {
    name: "Cooperative",
  };
</script>
